module.exports = __webpack_public_path__ + "assets/img/DS-kitchen (1).17842aea.jpg";